import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { LoginService } from '../../login/login.service';
import { NotificationService } from '../notification.service';

@Component({
  selector: 'app-dialog-rememberpwd',
  templateUrl: 'dialog-rememberpwd.component.html',
})
export class DialogRememberPwdComponent {
  public form: FormGroup;
  public isSaving = false;

  constructor(
    public dialogRef: MatDialogRef<DialogRememberPwdComponent>,
    private fb: FormBuilder,
    private loginService: LoginService,
    private notification: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.buildForm();
  }

  onSend(): void {
    this.isSaving = true;
    this.loginService
      .sendRememberPwd(this.form.value.email)
      .then(() => {
        this.notification.success('Se han enviado instrucciones a su correo electronico');
        this.dialogRef.close();
      })
      .catch((reason) => {
        this.notification.error('No fue posible ejecutar esta operación, verifique que el correo sea válido');
        console.error(reason);
      })
      .finally(() => (this.isSaving = false));
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * crear el formulario
   */
  private buildForm() {
    this.form = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
    });
  }
}
